import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { ITextArea } from 'components/uiKit/TextArea'
import TextArea from 'components/uiKit/TextArea'

const FieldTextArea = ({ name, onChange, ...rest }: AdapterKitControlProps<ITextArea, string>) => {
  const handleChange = useCallback((value: string) => onChange({ name, value }), [name, onChange])

  return <TextArea {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldTextArea) as typeof FieldTextArea
